export default __webpack_public_path__ + "static/media/Pe-icon-7-stroke.09c6a965.svg";